
import React from 'react';
import SpinnerSVG from '../assets/bouncing-circles.svg';

const LoadingSpinner = ({ size = 50, alt = 'Loading...' }) => {
    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <img
                src={SpinnerSVG}
                alt={alt}
                width={size}
                height={size}
            />
        </div>
    );
};

export default LoadingSpinner;
